import { ApiEndpoint, FormType, InputMod, InputType, Translation } from '@enums';
import i18n from '@translations';
import type { EndpointType, FormConfig, FormConfigMapping, FormConfigMappingReturn, OptionItem } from '@types';

interface GetSecurityFormConfigParams {
  endpoint?: EndpointType;
  options?: OptionItem[];
  loading?: boolean;
}

export const getPageRulesFormConfig = ({
  endpoint = ApiEndpoint.DEFAULT,
  options = [],
  loading = false,
}: GetSecurityFormConfigParams): FormConfig => {
  const PAGE_RULES_FORM: FormConfigMapping = {
    [ApiEndpoint.DEFAULT]: {
      formType: FormType.CdnPageRules,
      endpoint: ApiEndpoint.DEFAULT,
      inputList: [
        {
          name: 'http_redirection',
          label: i18n.t(`${Translation.Configuration}:forms.pageRules.redirection`),
          description: i18n.t(
            `${Translation.Configuration}:forms.pageRules.chooseHowYouWouldLikeToHandleHTTPAndHTTPSRedirectionForYourSite`,
          ),
          placeholder: i18n.t(`${Translation.Configuration}:forms.pageRules.pleaseSelectYourRedirectDestination`),
          inputType: InputType.Select,
          inputMod: InputMod.Filled,
          withoutLabel: true,
          options,
          loading,
        },
      ],
    },
  };

  return PAGE_RULES_FORM?.[endpoint as keyof FormConfigMappingReturn];
};
